import React from 'react';
import { Outlet } from 'react-router-dom';
import SidebarV2 from '../navigation/SidebarV2';

/**
 * AgentShell - Layout wrapper for Agent pages
 * Renders Sidebar (SidebarV2) + content area (via Outlet)
 * Topbar is handled by AppChrome parent
 */
const AgentShell = () => {
  return (
    <div className="flex flex-1 min-h-0 w-full">
      <SidebarV2 />
      <main className="overflow-auto flex-1 min-w-0 p-6 bg-gray-50">
        <div className="mx-auto max-w-7xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AgentShell;

